import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function updateSchool(notification) {
	return fetch(
		`${ENDPOINT_URL}/updateschool`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify(notification),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
